function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var email = require('./email');
var _require = require('./transactions'),
  createMigrationPayoutTransaction = _require.createMigrationPayoutTransaction,
  createBuySaitoPayoutTransaction = _require.createBuySaitoPayoutTransaction,
  createTreasuryPayoutRequestTransaction = _require.createTreasuryPayoutRequestTransaction,
  restoreSavedSignedTransaction = _require.restoreSavedSignedTransaction;
var PAYOUT_PURPOSES = new Set(['migration', 'buysaito', 'store-purchase']);
function configuredKeys(value) {
  if (!Array.isArray(value)) {
    return [];
  }
  return value.map(function (key) {
    return String(key || '').trim();
  }).filter(Boolean);
}
function positiveAmount(value) {
  var text = String(value !== null && value !== void 0 ? value : '').trim();
  if (!/^\d+(\.\d+)?$/.test(text) || !(Number(text) > 0)) {
    return '';
  }
  return text;
}
function positiveInteger(value) {
  var number = typeof value === 'number' ? value : Number(String(value !== null && value !== void 0 ? value : '').trim());
  if (!Number.isSafeInteger(number) || number <= 0) {
    return 0;
  }
  return number;
}
function responseOf(result) {
  if (result && typeof result.returnMessage === 'function') {
    try {
      return result.returnMessage();
    } catch (err) {
      return null;
    }
  }
  return result && _typeof(result) === 'object' ? result : null;
}
function requestRecipient(tx) {
  if (typeof (tx === null || tx === void 0 ? void 0 : tx.to) === 'string') {
    return tx.to.trim();
  }
  var slip = Array.isArray(tx === null || tx === void 0 ? void 0 : tx.to) ? tx.to[0] : null;
  return String((slip === null || slip === void 0 ? void 0 : slip.publicKey) || (slip === null || slip === void 0 ? void 0 : slip.add) || '').trim();
}
function authorizedTreasurySigner(mod, signer) {
  var key = String(signer || '').trim();
  if (!key) {
    return false;
  }
  if (key === String(mod.publicKey || '').trim()) {
    return true;
  }
  return configuredKeys(mod.treasury_delegate_publickeys).includes(key);
}
function selectTreasuryProvider(_x) {
  return _selectTreasuryProvider.apply(this, arguments);
}
function _selectTreasuryProvider() {
  _selectTreasuryProvider = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(mod) {
    var own, _iterator, _step, _mod$app, key, _mod$app2, _mod$app2$getPeer, peer, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          own = String(mod.publicKey || '').trim();
          _iterator = _createForOfIteratorHelper(configuredKeys(mod.treasury_provider_publickeys));
          _context.p = 1;
          _iterator.s();
        case 2:
          if ((_step = _iterator.n()).done) {
            _context.n = 9;
            break;
          }
          key = _step.value;
          if (!(!key || key === own)) {
            _context.n = 3;
            break;
          }
          return _context.a(3, 8);
        case 3:
          if (!(typeof ((_mod$app = mod.app) === null || _mod$app === void 0 || (_mod$app = _mod$app.crypto) === null || _mod$app === void 0 ? void 0 : _mod$app.isPublicKey) === 'function' && !mod.app.crypto.isPublicKey(key))) {
            _context.n = 4;
            break;
          }
          return _context.a(3, 8);
        case 4:
          _context.p = 4;
          _context.n = 5;
          return (_mod$app2 = mod.app) === null || _mod$app2 === void 0 || (_mod$app2 = _mod$app2.network) === null || _mod$app2 === void 0 || (_mod$app2$getPeer = _mod$app2.getPeer) === null || _mod$app2$getPeer === void 0 ? void 0 : _mod$app2$getPeer.call(_mod$app2, key);
        case 5:
          peer = _context.v;
          if (!peer) {
            _context.n = 6;
            break;
          }
          return _context.a(2, key);
        case 6:
          _context.n = 8;
          break;
        case 7:
          _context.p = 7;
          _t = _context.v;
          return _context.a(3, 8);
        case 8:
          _context.n = 2;
          break;
        case 9:
          _context.n = 11;
          break;
        case 10:
          _context.p = 10;
          _t2 = _context.v;
          _iterator.e(_t2);
        case 11:
          _context.p = 11;
          _iterator.f();
          return _context.f(11);
        case 12:
          return _context.a(2, '');
      }
    }, _callee, null, [[4, 7], [1, 10, 11, 12]]);
  }));
  return _selectTreasuryProvider.apply(this, arguments);
}
function reject(reason) {
  return {
    request_status: 'rejected',
    reason: reason,
    transfer_id: null,
    transfer_status: null,
    replayed: false
  };
}
function receiveTreasuryPayout(_x2, _x3) {
  return _receiveTreasuryPayout.apply(this, arguments);
}
function _receiveTreasuryPayout() {
  _receiveTreasuryPayout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(mod, tx) {
    var _tx$returnMessage, _tx$from, _mod$app3, _saved, _saved2, _saved3, _saved4;
    var message, signer, data, sourceTransferId, amount, recipient, purpose, fulfillsLocally, saved, _saved$treasury, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          message = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || {};
          if (!(message.request !== 'mixin-issue-treasury-payout' || !message.data || _typeof(message.data) !== 'object')) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, reject('That transaction is not a treasury payout request.'));
        case 1:
          signer = String(((_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || '').trim();
          if (!(!tx.signature || !signer || typeof tx.isValid !== 'function' || tx.isValid() !== true)) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, reject('The payout request signature is not valid.'));
        case 2:
          data = message.data;
          if (!(String(data.requester_publickey || '').trim() !== signer)) {
            _context2.n = 3;
            break;
          }
          return _context2.a(2, reject('The payout request signer does not match the requester.'));
        case 3:
          if (authorizedTreasurySigner(mod, signer)) {
            _context2.n = 4;
            break;
          }
          return _context2.a(2, reject('The payout request signer is not an authorized treasury delegate.'));
        case 4:
          if (!(typeof tx.isTo === 'function' && tx.isTo(mod.publicKey) !== true)) {
            _context2.n = 5;
            break;
          }
          return _context2.a(2, reject('The payout request is not addressed to this treasury.'));
        case 5:
          sourceTransferId = positiveInteger(data.source_transfer_id);
          amount = positiveAmount(data.outbound_amount);
          recipient = String(data.recipient_publickey || '').trim();
          purpose = String(data.purpose || '').trim();
          if (!(!sourceTransferId || !PAYOUT_PURPOSES.has(purpose) || !amount)) {
            _context2.n = 6;
            break;
          }
          return _context2.a(2, reject('The payout request is missing a valid transfer, purpose, or amount.'));
        case 6:
          if (!(typeof ((_mod$app3 = mod.app) === null || _mod$app3 === void 0 || (_mod$app3 = _mod$app3.crypto) === null || _mod$app3 === void 0 ? void 0 : _mod$app3.isPublicKey) !== 'function' || !mod.app.crypto.isPublicKey(recipient))) {
            _context2.n = 7;
            break;
          }
          return _context2.a(2, reject('The payout recipient is not a valid public key.'));
        case 7:
          if (!(purpose === 'store-purchase' && (!String(data.inbound_tx_hash || '').trim() || !data.payload))) {
            _context2.n = 8;
            break;
          }
          return _context2.a(2, reject('The store purchase request is missing its payment evidence.'));
        case 8:
          fulfillsLocally = typeof mod.performsLocalFulfillment === 'function' ? mod.performsLocalFulfillment() : mod.fulfillment_mode === 'local' || mod.fulfillment_mode === 'treasury';
          if (!(mod.payout_mode !== 'local' || !fulfillsLocally)) {
            _context2.n = 9;
            break;
          }
          return _context2.a(2, {
            request_status: 'error',
            reason: 'This node is not accepting treasury payout requests.',
            transfer_id: null,
            transfer_status: null,
            replayed: false
          });
        case 9:
          _context2.p = 9;
          _context2.n = 10;
          return mod.database.recordRemoteTreasuryPayout({
            requester_publickey: signer,
            source_transfer_id: sourceTransferId,
            request_tx: typeof tx.serialize_to_web === 'function' ? tx.serialize_to_web(mod.app) : '',
            request_tx_sig: tx.signature,
            request_payload: JSON.stringify(data),
            request_id: "".concat(signer, ":").concat(sourceTransferId),
            recipient_publickey: recipient,
            outbound_amount: amount,
            payload: data.payload || '',
            inbound_tx_hash: String(data.inbound_tx_hash || '').trim(),
            inbound_ticker: String(data.inbound_ticker || '').trim(),
            inbound_amount: data.inbound_amount ? String(data.inbound_amount) : ''
          });
        case 10:
          saved = _context2.v;
          _context2.n = 12;
          break;
        case 11:
          _context2.p = 11;
          _t3 = _context2.v;
          return _context2.a(2, {
            request_status: 'error',
            reason: (_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || 'The treasury request could not be recorded.',
            transfer_id: null,
            transfer_status: null,
            replayed: false
          });
        case 12:
          if (!((_saved = saved) !== null && _saved !== void 0 && _saved.rejected)) {
            _context2.n = 13;
            break;
          }
          return _context2.a(2, reject(saved.reason));
        case 13:
          if (!((_saved2 = saved) !== null && _saved2 !== void 0 && _saved2.conflict)) {
            _context2.n = 14;
            break;
          }
          return _context2.a(2, {
            request_status: 'error',
            reason: 'That transfer already has a different signed treasury request.',
            transfer_id: ((_saved$treasury = saved.treasury) === null || _saved$treasury === void 0 ? void 0 : _saved$treasury.transfer_id) || null,
            transfer_status: null,
            replayed: false
          });
        case 14:
          if (!(!((_saved3 = saved) !== null && _saved3 !== void 0 && (_saved3 = _saved3.transfer) !== null && _saved3 !== void 0 && _saved3.id) || !((_saved4 = saved) !== null && _saved4 !== void 0 && (_saved4 = _saved4.treasury) !== null && _saved4 !== void 0 && _saved4.id))) {
            _context2.n = 15;
            break;
          }
          return _context2.a(2, {
            request_status: 'error',
            reason: 'The treasury request was not recorded.',
            transfer_id: null,
            transfer_status: null,
            replayed: false
          });
        case 15:
          return _context2.a(2, {
            request_status: 'accepted',
            reason: '',
            transfer_id: saved.transfer.id,
            transfer_status: saved.transfer.status,
            replayed: !!saved.replayed
          });
      }
    }, _callee2, null, [[9, 11]]);
  }));
  return _receiveTreasuryPayout.apply(this, arguments);
}
function applyTreasuryResponse(_x4, _x5, _x6) {
  return _applyTreasuryResponse.apply(this, arguments);
}
function _applyTreasuryResponse() {
  _applyTreasuryResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(mod, transferId, raw) {
    var _yield$mod$database$g, _yield$mod$database$g2;
    var current, response, audit, reason, _reason, _t4, _t5, _t6, _t7, _t8, _t9, _t0;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return mod.database.getTransfers({
            id: transferId
          });
        case 1:
          _t5 = _yield$mod$database$g = _context3.v;
          _t4 = _t5 === null;
          if (_t4) {
            _context3.n = 2;
            break;
          }
          _t4 = _yield$mod$database$g === void 0;
        case 2:
          if (!_t4) {
            _context3.n = 3;
            break;
          }
          _t6 = void 0;
          _context3.n = 4;
          break;
        case 3:
          _t6 = _yield$mod$database$g[0];
        case 4:
          current = _t6;
          if (!(!current || current.status === 'treasury_accepted' || current.status === 'treasury_rejected')) {
            _context3.n = 5;
            break;
          }
          return _context3.a(2, current);
        case 5:
          response = responseOf(raw);
          _context3.n = 6;
          return mod.database.findLocalTreasury(transferId);
        case 6:
          audit = _context3.v;
          if (!((response === null || response === void 0 ? void 0 : response.request_status) === 'accepted' && response.transfer_id)) {
            _context3.n = 9;
            break;
          }
          _context3.n = 7;
          return mod.database.updateTransfer(transferId, {
            status: 'treasury_accepted',
            last_error: ''
          });
        case 7:
          if (!audit) {
            _context3.n = 8;
            break;
          }
          _context3.n = 8;
          return mod.database.updateTreasury(audit.id, {
            status: 'accepted',
            remote_transfer_id: response.transfer_id || null,
            last_error: ''
          });
        case 8:
          _context3.n = 14;
          break;
        case 9:
          if (!((response === null || response === void 0 ? void 0 : response.request_status) === 'rejected')) {
            _context3.n = 12;
            break;
          }
          reason = String(response.reason || 'Treasury rejected the payout request.');
          _context3.n = 10;
          return mod.database.updateTransfer(transferId, {
            status: 'treasury_rejected',
            last_error: reason
          });
        case 10:
          if (!audit) {
            _context3.n = 11;
            break;
          }
          _context3.n = 11;
          return mod.database.updateTreasury(audit.id, {
            status: 'rejected',
            last_error: reason
          });
        case 11:
          _context3.n = 14;
          break;
        case 12:
          if (!response) {
            _context3.n = 14;
            break;
          }
          _reason = String(response.reason || response.err || 'Treasury response was not recognized.');
          _context3.n = 13;
          return mod.database.updateTransfer(transferId, {
            last_error: _reason
          });
        case 13:
          if (!audit) {
            _context3.n = 14;
            break;
          }
          _context3.n = 14;
          return mod.database.updateTreasury(audit.id, {
            last_error: _reason
          });
        case 14:
          _context3.n = 15;
          return mod.database.getTransfers({
            id: transferId
          });
        case 15:
          _t9 = _yield$mod$database$g2 = _context3.v;
          _t8 = _t9 === null;
          if (_t8) {
            _context3.n = 16;
            break;
          }
          _t8 = _yield$mod$database$g2 === void 0;
        case 16:
          if (!_t8) {
            _context3.n = 17;
            break;
          }
          _t0 = void 0;
          _context3.n = 18;
          break;
        case 17:
          _t0 = _yield$mod$database$g2[0];
        case 18:
          _t7 = _t0;
          if (_t7) {
            _context3.n = 19;
            break;
          }
          _t7 = current;
        case 19:
          return _context3.a(2, _t7);
      }
    }, _callee3);
  }));
  return _applyTreasuryResponse.apply(this, arguments);
}
function forwardTreasuryPayout(_x7, _x8) {
  return _forwardTreasuryPayout.apply(this, arguments);
}
function _forwardTreasuryPayout() {
  _forwardTreasuryPayout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(mod, row) {
    var _yield$mod$database$g3, _mod$app4;
    var fresh, audit, tx, _tx$returnMessage2, _tx, _tx$msg, provider, requester, serialized, recipient, applications, _t1, _t10, _t11, _t12, _t13;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          _context4.n = 1;
          return mod.database.getTransfers({
            id: row.id
          });
        case 1:
          _t11 = _yield$mod$database$g3 = _context4.v;
          _t10 = _t11 === null;
          if (_t10) {
            _context4.n = 2;
            break;
          }
          _t10 = _yield$mod$database$g3 === void 0;
        case 2:
          if (!_t10) {
            _context4.n = 3;
            break;
          }
          _t12 = void 0;
          _context4.n = 4;
          break;
        case 3:
          _t12 = _yield$mod$database$g3[0];
        case 4:
          _t1 = _t12;
          if (_t1) {
            _context4.n = 5;
            break;
          }
          _t1 = row;
        case 5:
          fresh = _t1;
          if (!(mod.payout_mode !== 'remote' || !PAYOUT_PURPOSES.has(fresh.purpose))) {
            _context4.n = 6;
            break;
          }
          return _context4.a(2, fresh);
        case 6:
          if (!(fresh.outbound_tx_sig || fresh.status === 'treasury_accepted' || fresh.status === 'treasury_rejected')) {
            _context4.n = 7;
            break;
          }
          return _context4.a(2, fresh);
        case 7:
          _context4.n = 8;
          return mod.database.findLocalTreasury(fresh.id);
        case 8:
          audit = _context4.v;
          tx = audit ? restoreSavedSignedTransaction(mod.app, audit.request_tx, audit.request_tx_sig) : null;
          if (!(audit && !tx)) {
            _context4.n = 12;
            break;
          }
          _context4.n = 9;
          return mod.database.updateTransfer(fresh.id, {
            status: 'treasury_submitted',
            last_error: 'The saved treasury request could not be restored.'
          });
        case 9:
          _context4.n = 10;
          return mod.database.updateTreasury(audit.id, {
            last_error: 'The saved treasury request could not be restored.'
          });
        case 10:
          _context4.n = 11;
          return mod.database.getTransfers({
            id: fresh.id
          });
        case 11:
          return _context4.a(2, _context4.v[0]);
        case 12:
          if (tx) {
            _context4.n = 22;
            break;
          }
          _context4.n = 13;
          return selectTreasuryProvider(mod);
        case 13:
          provider = _context4.v;
          if (provider) {
            _context4.n = 16;
            break;
          }
          _context4.n = 14;
          return mod.database.updateTransfer(fresh.id, {
            last_error: 'treasury_provider_unreachable'
          });
        case 14:
          _context4.n = 15;
          return mod.database.getTransfers({
            id: fresh.id
          });
        case 15:
          return _context4.a(2, _context4.v[0]);
        case 16:
          requester = String(mod.publicKey || '').trim();
          if (requester) {
            _context4.n = 19;
            break;
          }
          _context4.n = 17;
          return mod.database.updateTransfer(fresh.id, {
            last_error: 'The application server has no public key.'
          });
        case 17:
          _context4.n = 18;
          return mod.database.getTransfers({
            id: fresh.id
          });
        case 18:
          return _context4.a(2, _context4.v[0]);
        case 19:
          _context4.n = 20;
          return createTreasuryPayoutRequestTransaction(mod.app, provider, fresh, requester);
        case 20:
          tx = _context4.v;
          serialized = tx.serialize_to_web(mod.app);
          _context4.n = 21;
          return mod.database.saveLocalTreasuryRequest({
            requester_publickey: requester,
            source_transfer_id: Number(fresh.id),
            transfer_id: Number(fresh.id),
            request_tx: serialized,
            request_tx_sig: tx.signature,
            request_payload: JSON.stringify(((_tx$returnMessage2 = (_tx = tx).returnMessage) === null || _tx$returnMessage2 === void 0 || (_tx$returnMessage2 = _tx$returnMessage2.call(_tx)) === null || _tx$returnMessage2 === void 0 ? void 0 : _tx$returnMessage2.data) || ((_tx$msg = tx.msg) === null || _tx$msg === void 0 ? void 0 : _tx$msg.data) || {})
          });
        case 21:
          audit = _context4.v;
          tx = restoreSavedSignedTransaction(mod.app, audit.request_tx, audit.request_tx_sig) || tx;
        case 22:
          _context4.n = 23;
          return mod.database.updateTransfer(fresh.id, {
            status: 'treasury_submitted',
            last_error: ''
          });
        case 23:
          recipient = requestRecipient(tx);
          if (!(!recipient || typeof ((_mod$app4 = mod.app) === null || _mod$app4 === void 0 || (_mod$app4 = _mod$app4.network) === null || _mod$app4 === void 0 ? void 0 : _mod$app4.sendTransactionWithCallback) !== 'function')) {
            _context4.n = 26;
            break;
          }
          _context4.n = 24;
          return mod.database.updateTransfer(fresh.id, {
            last_error: 'treasury_provider_unreachable'
          });
        case 24:
          _context4.n = 25;
          return mod.database.getTransfers({
            id: fresh.id
          });
        case 25:
          return _context4.a(2, _context4.v[0]);
        case 26:
          applications = [];
          _context4.p = 27;
          _context4.n = 28;
          return mod.app.network.sendTransactionWithCallback(tx, function (response) {
            applications.push(applyTreasuryResponse(mod, fresh.id, response));
          }, recipient);
        case 28:
          _context4.n = 29;
          return Promise.all(applications);
        case 29:
          _context4.n = 31;
          break;
        case 30:
          _context4.p = 30;
          _t13 = _context4.v;
          _context4.n = 31;
          return mod.database.updateTransfer(fresh.id, {
            last_error: String((_t13 === null || _t13 === void 0 ? void 0 : _t13.message) || _t13)
          });
        case 31:
          _context4.n = 32;
          return mod.database.getTransfers({
            id: fresh.id
          });
        case 32:
          return _context4.a(2, _context4.v[0]);
      }
    }, _callee4, null, [[27, 30]]);
  }));
  return _forwardTreasuryPayout.apply(this, arguments);
}
function issueQueuedTreasuryPayout(_x9, _x0) {
  return _issueQueuedTreasuryPayout.apply(this, arguments);
}
function _issueQueuedTreasuryPayout() {
  _issueQueuedTreasuryPayout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(mod, row) {
    var audit, data, sourceId, purpose, signingRow, amount, required, available, _mod$app$core, _mod$app$core$getPend, pending, signed, recipient, issued, _t14, _t15;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          _context5.n = 1;
          return mod.database.findTreasuryByTransfer(row.id);
        case 1:
          audit = _context5.v;
          data = {};
          try {
            data = audit !== null && audit !== void 0 && audit.request_payload ? JSON.parse(audit.request_payload) : {};
          } catch (err) {
            data = {};
          }
          sourceId = positiveInteger(data.source_transfer_id || (audit === null || audit === void 0 ? void 0 : audit.source_transfer_id));
          purpose = String(data.purpose || '').trim();
          if (!(!audit || !sourceId || !PAYOUT_PURPOSES.has(purpose))) {
            _context5.n = 4;
            break;
          }
          if (!(row.last_error !== 'The treasury payout is missing its signed request.')) {
            _context5.n = 2;
            break;
          }
          _context5.n = 2;
          return mod.database.updateTransfer(row.id, {
            last_error: 'The treasury payout is missing its signed request.'
          });
        case 2:
          _context5.n = 3;
          return mod.database.getTransfers({
            id: row.id
          });
        case 3:
          return _context5.a(2, _context5.v[0]);
        case 4:
          signingRow = _objectSpread(_objectSpread({}, row), {}, {
            id: sourceId,
            purpose: purpose,
            payload: data.payload || '',
            inbound_tx_hash: data.inbound_tx_hash || '',
            inbound_ticker: data.inbound_ticker || '',
            inbound_amount: data.inbound_amount || '',
            outbound_amount: data.outbound_amount || row.outbound_amount,
            recipient_publickey: data.recipient_publickey || row.recipient_publickey,
            requester_publickey: data.requester_publickey || row.requester_publickey
          });
          amount = signingRow.outbound_amount;
          if (purpose === 'migration') {
            amount = mod.migration.allocationForDeposit(signingRow.outbound_amount);
            signingRow.outbound_amount = String(amount);
          }
          required = mod.app.wallet.convertSaitoToNolan(amount);
          _context5.n = 5;
          return mod.app.wallet.getBalance();
        case 5:
          available = _context5.v;
          if (!(typeof available !== 'bigint' || typeof required !== 'bigint' || required <= 0n)) {
            _context5.n = 6;
            break;
          }
          throw new Error('Invalid payout balance or amount');
        case 6:
          if (!(available < required)) {
            _context5.n = 15;
            break;
          }
          if (!(purpose === 'buysaito')) {
            _context5.n = 11;
            break;
          }
          _context5.p = 7;
          _context5.n = 8;
          return (_mod$app$core = mod.app.core) === null || _mod$app$core === void 0 || (_mod$app$core = _mod$app$core.wallet) === null || _mod$app$core === void 0 || (_mod$app$core$getPend = _mod$app$core.getPendingBalance) === null || _mod$app$core$getPend === void 0 ? void 0 : _mod$app$core$getPend.call(_mod$app$core);
        case 8:
          pending = _context5.v;
          if (!(typeof pending === 'bigint' && pending >= required)) {
            _context5.n = 9;
            break;
          }
          return _context5.a(2, row);
        case 9:
          _context5.n = 11;
          break;
        case 10:
          _context5.p = 10;
          _t14 = _context5.v;
          console.error("Mixin transfer ".concat(row.id, " pending balance check failed:"), _t14);
          return _context5.a(2, row);
        case 11:
          if (!(row.last_error !== 'insufficient_funds')) {
            _context5.n = 13;
            break;
          }
          _context5.n = 12;
          return mod.database.updateTransfer(row.id, {
            last_error: 'insufficient_funds'
          });
        case 12:
          if (purpose === 'migration') {
            email.sendLowBalanceEmail(mod.app, amount);
          }
        case 13:
          _context5.n = 14;
          return mod.database.getTransfers({
            id: row.id
          });
        case 14:
          return _context5.a(2, _context5.v[0]);
        case 15:
          recipient = signingRow.recipient_publickey;
          if (!(purpose === 'migration')) {
            _context5.n = 17;
            break;
          }
          _context5.n = 16;
          return createMigrationPayoutTransaction(mod.app, signingRow, amount);
        case 16:
          signed = _context5.v;
          _context5.n = 23;
          break;
        case 17:
          _context5.p = 17;
          _context5.n = 18;
          return createBuySaitoPayoutTransaction(mod.app, signingRow, required);
        case 18:
          issued = _context5.v;
          signed = issued.tx;
          recipient = issued.recipient;
          _context5.n = 23;
          break;
        case 19:
          _context5.p = 19;
          _t15 = _context5.v;
          if (!((_t15 === null || _t15 === void 0 ? void 0 : _t15.message) === 'Store purchase is missing its inbound payment id or transfer id')) {
            _context5.n = 22;
            break;
          }
          if (!(row.last_error !== _t15.message)) {
            _context5.n = 20;
            break;
          }
          _context5.n = 20;
          return mod.database.updateTransfer(row.id, {
            last_error: _t15.message
          });
        case 20:
          _context5.n = 21;
          return mod.database.getTransfers({
            id: row.id
          });
        case 21:
          return _context5.a(2, _context5.v[0]);
        case 22:
          throw _t15;
        case 23:
          _context5.n = 24;
          return mod.database.updateTransfer(row.id, {
            status: 'outbound_awaiting',
            outbound_tx: signed.serialize_to_web(mod.app),
            outbound_tx_sig: signed.signature,
            outbound_amount: String(amount),
            outbound_address: recipient,
            outbound_ticker: 'SAITO',
            last_error: ''
          });
        case 24:
          if (purpose === 'migration') {
            email.sendStatusEmail(mod.app, 1, _objectSpread(_objectSpread({}, signingRow), {}, {
              outbound_amount: String(amount)
            }));
          }
          _context5.n = 25;
          return mod.database.getTransfers({
            id: row.id
          });
        case 25:
          return _context5.a(2, _context5.v[0]);
      }
    }, _callee5, null, [[17, 19], [7, 10]]);
  }));
  return _issueQueuedTreasuryPayout.apply(this, arguments);
}
module.exports = {
  receiveTreasuryPayout: receiveTreasuryPayout,
  forwardTreasuryPayout: forwardTreasuryPayout,
  issueQueuedTreasuryPayout: issueQueuedTreasuryPayout,
  selectTreasuryProvider: selectTreasuryProvider
};